export const ALL = 'ALL';
export const CORRECT_ONLY = 'CORRECT_ONLY';
export const MAX_ONE_ERROR = 'MAX_ONE_ERROR';
export const MAX_TWO_ERRORS = 'MAX_TWO_ERRORS';
